import analytics from '@clearbit-dcp/clearbit.js-core';
import clearbit from '@clearbit-dcp/clearbit.js-integration-clearbit';

analytics.use(clearbit);

export default analytics;
